import React from 'react';
import { Popover, Button, Icon, Input } from 'antd';

export const ImageUrl = ({ onChange, params }) => {
  const changeSort = () => {
    let order;

    if (params?.order === '') {
      order = 'asc';
    } else if (params?.order === 'asc') {
      order = 'desc';
    } else {
      order = '';
    }

    onChange({ ...params, order });
  };

  const content = (
    <>
      <div style={{ marginBottom: 8 }} onClick={changeSort}>
        <b style={{ marginRight: 5 }}>Sort:</b>
        {!params?.order && <Icon type='column-height' />}
        {params?.order === 'asc' && <Icon type='sort-ascending' />}
        {params?.order === 'desc' && <Icon type='sort-descending' />}
      </div>
      <Input
        value={params?.value}
        placeholder='Image URL'
        style={{ width: '150px' }}
        onChange={(e) => {
          onChange({ ...params, value: e.target.value });
        }}
        allowClear
      ></Input>
    </>
  );

  return (
    <Popover content={content} title='Image URL' trigger='click'>
      <Button className='sighting-filter' style={{ width: '35%' }}>
        Image URL
        <Icon type='down' style={{ color: '#d9d9d9' }} />
      </Button>
    </Popover>
  );
};
